import { ChevronDownIcon } from "lucide-react";
import { Dispatch, ReactNode, SetStateAction } from "react";

import { Button } from "@/components/ui/button";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_NOTIFICATION_SURFACES, MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { cn } from "@/lib/utils";
import { NotificationType } from "@/types";

// Expand/collapse toggle shared by every notification payload list.
export const NotificationExpandToggle = ({
  children,
  isExpanded,
  notificationType,
  setIsExpanded,
  trackingSurface,
}: {
  children: ReactNode;
  isExpanded: boolean;
  notificationType: NotificationType;
  setIsExpanded: Dispatch<SetStateAction<boolean>>;
  trackingSurface: MIXPANEL_NOTIFICATION_SURFACES;
}) => {
  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!isExpanded) {
      mixpanelUtils.trackButtonClick(
        "Expand notification list",
        MIXPANEL_SCREENS.NOTIFICATIONS,
        { notification_type: notificationType, surface: trackingSurface },
      );
    }
    setIsExpanded((current) => !current);
  };

  return (
    <Button
      className="h-6 w-fit gap-1 px-1.5 text-xs font-medium text-slate-500"
      onClick={handleToggle}
      size="sm"
      type="button"
      variant="ghost"
    >
      {children}
      <ChevronDownIcon
        className={cn(
          "h-3.5 w-3.5 transition-transform",
          isExpanded && "rotate-180",
        )}
      />
    </Button>
  );
};
